import axios from 'axios'
import moment from 'moment'
import Utils from '../services/Utils'

export default {
    getAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).chat
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).chat
        return 'Basic ' + window.btoa(user + ':' + password)
    },
    validateChatToken: function (callback) {
        const currentDate = moment.utc().format('YYYY-MM-DDTHH:mm:ss')
        if (!axios.defaults.chatAuthorizationToken || !axios.defaults.chatAuthorizationExpireDate || (axios.defaults.chatAuthorizationExpireDate && axios.defaults.chatAuthorizationExpireDate <= currentDate)) {
            axios.post(axios.defaults.chatApiUrl + 'login?lng=' + window.language,
                {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.getAuthorization()
                }
            }).then((response) => {
                if (response.status === 200 && response.data && response.data.data && response.data.data.id) {
                    axios.defaults.chatAuthorizationExpireDate = moment.utc().add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss')
                    axios.defaults.chatAuthorizationToken = 'Bearer ' + response.data.data.id
                } else {
                    axios.defaults.chatAuthorizationExpireDate = null
                    axios.defaults.chatAuthorizationToken = null
                }
                callback()
            }).catch(() => {
                axios.defaults.chatAuthorizationExpireDate = null
                axios.defaults.chatAuthorizationToken = null
                callback()
            })
        } else {
            callback()
        }
    },
    newUser(data, callback) {
        this.validateChatToken(function () {
            axios.post(axios.defaults.chatApiUrl + 'user',
                data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': axios.defaults.chatAuthorizationToken
                }
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        })
    },
    getUser(id, callback) {
        this.validateChatToken(function () {
            axios.get(axios.defaults.chatApiUrl + 'user?filter={"id":' + id + '}', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.chatAuthorizationToken
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        })
    },
    getUserByEmail(email, callback) {
        this.validateChatToken(function () {
            axios.get(axios.defaults.chatApiUrl + 'user?filter={"email":"' + email + '"}&fields=["id"]', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.chatAuthorizationToken
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        })
    },
    newChat(data, callback) {
        this.validateChatToken(function () {
            axios.post(axios.defaults.chatApiUrl + 'chat',
                data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: axios.defaults.chatAuthorizationToken
                }
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        })
    },
}
